module.exports = __webpack_public_path__ + "img/logo-white.7621cf1a.svg";